import React, { Component } from 'react';
import { PDFViewer, Page, Text, Image, Document, View, StyleSheet } from '@react-pdf/renderer';

import { ESTILOS } from './Styles/StylesBeca';

import PlanillaBecaPag1 from "./PlanillaBecaPag1";
import PlanillaBecaPag2 from "./PlanillaBecaPag2";
import PlanillaBecaPag3 from "./PlanillaBecaPag3";
import PlanillaBecaPag4 from "./PlanillaBecaPag4";

class PlanillaBeca extends Component {
    render() {
        let { data1, data2, personal, data3, carrera } = this.props;

        const styles = StyleSheet.create(ESTILOS[0]);
        return (
            <PDFViewer style={styles.section}>
                <Document title="Solicitud de Ayuda Económica">
                    <Page size="letter" style={styles.body}>
                        <View><PlanillaBecaPag1 data1 = {data1} data2 = {data2} personal = {personal} data3 = {data3} carrera = {carrera}/></View>
                    </Page>
                    <Page size="letter" style={styles.body}>
                        <View><PlanillaBecaPag2 data3 = {data3}/></View>
                    </Page>
                    <Page size="letter" style={styles.body}>
                        <View><PlanillaBecaPag3 data3 = {data3}/></View>
                    </Page>
                    <Page size="letter" style={styles.body}>
                        <View><PlanillaBecaPag4 requisitos = {data3.requisitos_beca}/></View>
                    </Page>
                </Document>
            </PDFViewer>
        );
    }
}
 
export default PlanillaBeca;


// WEBPACK FOOTER //
// ./src/components/Reportes/PlanillaBeca.jsx